import React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, Divider, IconButton, Stack } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';

const sampleNotifications = [
  { type: 'success', message: 'Payment received for Loan #L120.' },
  { type: 'info', message: 'Loan #L123 disbursed to ABC Corp.' },
  { type: 'warning', message: '3 payments are due this week.' },
  { type: 'alert', message: 'System maintenance scheduled for Sunday.' }
];

const getNotifIcon = (type: string) => {
  switch (type) {
    case 'success':
      return <CheckCircleOutlineIcon sx={{ color: '#10B981' }} fontSize="medium" />;
    case 'info':
      return <InfoOutlinedIcon sx={{ color: '#6366F1' }} fontSize="medium" />;
    case 'warning':
      return <WarningAmberOutlinedIcon sx={{ color: '#F59E0B' }} fontSize="medium" />;
    case 'alert':
    case 'error':
      return <ErrorOutlineIcon sx={{ color: '#F43F5E' }} fontSize="medium" />;
    default:
      return <InfoOutlinedIcon fontSize="medium" />;
  }
};

const Notifications: React.FC = () => {
  return (
    <Box sx={{ width: '100%', maxWidth: 1100, mx: 'auto', mt: 4, px: { xs: 1, sm: 3 } }}>
      <Typography variant="h4" sx={{ mb: 4, fontWeight: 700, color: '#111827' }}>
        Notifications
      </Typography>
      <List disablePadding sx={{ bgcolor: '#fff', borderRadius: 2, border: '1px solid #E5E7EB', p: 0 }}>
        {sampleNotifications.length === 0 ? (
          <Typography sx={{ color: '#6B7280', textAlign: 'center', py: 4 }}>
            No notifications.
          </Typography>
        ) : (
          sampleNotifications.map((notif, idx) => (
            <React.Fragment key={idx}>
              <ListItem
                sx={{
                  py: 3,
                  px: { xs: 2, sm: 4 },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  '&:hover': { bgcolor: '#F5F6FF' },
                  transition: 'background 0.2s',
                }}
                secondaryAction={
                  <Stack direction="row" spacing={1}>
                    <IconButton color="primary" size="small">
                      <VisibilityIcon />
                    </IconButton>
                    <IconButton color="success" size="small">
                      <DoneIcon />
                    </IconButton>
                    <IconButton color="error" size="small">
                      <DeleteIcon />
                    </IconButton>
                  </Stack>
                }
              >
                <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, mr: 2 }}>
                  <ListItemIcon sx={{ minWidth: 40, mr: 1.5 }}>
                    {getNotifIcon(notif.type)}
                  </ListItemIcon>
                  <Typography sx={{ color: '#374151', fontSize: '1.05rem', flexGrow: 1 }}>{notif.message}</Typography>
                </Box>
              </ListItem>
              {idx < sampleNotifications.length - 1 && <Divider sx={{ mx: { xs: 2, sm: 4 } }} />}
            </React.Fragment>
          ))
        )}
      </List>
    </Box>
  );
};

export default Notifications; 